import React from 'react'
import { motion } from 'framer-motion'
import { BookOpen, Mic2, Building2, Guitar, Users, Wrench } from 'lucide-react'

const LinksHubPage = () => {
  const categories = [
    {
      title: 'Lessons & Workshops',
      icon: BookOpen,
      color: 'from-le-accent to-purple-600',
      links: [
        { name: 'Wichita Music Academy', url: '#', note: 'Private & group lessons' },
        { name: 'Community Classes', url: '#', note: 'Workshops and clinics' },
      ],
    },
    {
      title: 'Recording Studios',
      icon: Mic2,
      color: 'from-le-accent-2 to-cyan-600',
      links: [
        { name: 'River City Studios', url: '#', note: 'Full-service recording' },
        { name: 'Indie Lab', url: '#', note: 'Project studio' },
      ],
    },
    {
      title: 'Venues & Booking',
      icon: Building2,
      color: 'from-le-amber to-orange-600',
      links: [
        { name: 'The Wave', url: '#', note: 'Mid-size venue' },
        { name: 'Kirby’s', url: '#', note: 'Open mic friendly' },
      ],
    },
    {
      title: 'Gear & Retail',
      icon: Guitar,
      color: 'from-green-500 to-emerald-600',
      links: [
        { name: 'Local Shops Map', url: '#', note: 'Guitars, drums, PA' },
        { name: 'Authorized Service', url: '#', note: 'Repairs & parts' },
      ],
    },
    {
      title: 'Community & Blogs',
      icon: Users,
      color: 'from-pink-500 to-rose-600',
      links: [
        { name: 'Music Wichita', url: '#', note: 'Scene coverage' },
        { name: 'Local Reddit', url: '#', note: 'r/WichitaMusic' },
      ],
    },
    {
      title: 'Tools & Utilities',
      icon: Wrench,
      color: 'from-indigo-500 to-blue-600',
      links: [
        { name: 'Setlist Maker', url: '#', note: 'Plan your show' },
        { name: 'BPM & Key Tools', url: '#', note: 'Analyze tracks' },
      ],
    },
  ]

  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-16 bg-gradient-to-b from-le-darker/50 to-transparent">
        <div className="container-max">
          <motion.div
            className="text-center mb-12"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl lg:text-7xl font-display font-bold text-white mb-6">
              Wichita
              <span className="text-gradient block">Links Hub</span>
            </h1>
            <p className="text-2xl text-white/70 max-w-4xl mx-auto">
              Curated resources for musicians, venues, and fans. Click to visit. We periodically check availability and freshness.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories.map((cat, index) => {
              const Icon = cat.icon
              return (
                <motion.div
                  key={cat.title}
                  className="glass-card p-8 card-hover group"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.05 }}
                  viewport={{ once: true }}
                >
                  <div className={`w-16 h-16 bg-gradient-to-br ${cat.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <Icon size={28} className="text-white" />
                  </div>
                  <h3 className="text-xl font-display font-bold text-white mb-4 group-hover:text-le-accent transition-colors duration-300">{cat.title}</h3>
                  <ul className="space-y-3">
                    {cat.links.map((link) => (
                      <li key={link.name} className="flex items-center justify-between">
                        <a href={link.url} target="_blank" rel="noreferrer" className="text-white/80 hover:text-white transition-colors duration-200">
                          {link.name}
                        </a>
                        <span className="text-white/50 text-sm">{link.note}</span>
                      </li>
                    ))}
                  </ul>
                </motion.div>
              )
            })}
          </div>
        </div>
      </section>
    </div>
  )
}

export default LinksHubPage

